<div class="dialog-content-wrapper"
     id="verifica-controllo-modal">
    <mat-toolbar matDialogTitle
                 class="mat-accent m-0">
        <mat-toolbar-row fxLayout="row"
                         fxLayoutAlign="space-between center">
            <span class="title dialog-title">Aggiungi nota</span>
            <button mat-icon-button
                    (click)="dialogRef.close()"
                    aria-label="Close dialog">
                <mat-icon>close</mat-icon>
            </button>
        </mat-toolbar-row>
    </mat-toolbar>

    <div mat-dialog-content
         class="content m-0 p-24">
        <div fxLayout="column"
             fxLayoutAlign="">
            <!-- <div class="mat-title">
                Inserisci una nota
            </div> -->

            <!-- <mat-form-field class="mb-12">
                <mat-label>Annotazioni</mat-label>
                <textarea cdkTextareaAutosize
                          matInput
                          [(ngModel)]="annotazioni"
                          cdkAutosizeMinRows="1"
                          cdkAutosizeMaxRows="5"
                          maxlength="256"></textarea>
                <mat-hint align="end">{{annotazioni.length}} / 256</mat-hint>
            </mat-form-field> -->

            <!-- Annotazioni -->
            <mat-form-field appearance="outline">
                <mat-label>Annotazioni</mat-label>
                <textarea matInput
                          [(ngModel)]="annotazioni"></textarea>
            </mat-form-field>
        </div>
    </div>
    <div mat-dialog-actions
         class="p-24 m-0"
         align="end">
        <button mat-button
                (click)="dialogRef.close()">Annulla</button>

        <button mat-raised-button
                type="button"
                color="accent"
                [disabled]="confermaDisabled"
                (click)="onConferma()">
            Ok
        </button>
    </div>
</div>
